<div style="display: flex; height: 100%;">
  <div style="display: flex; overflow: hidden; width: 100%;">
    <div style="display: flex; flex-direction: column; margin: 20px; z-index: 1; overflow: hidden; width: 100%;">
      <mat-toolbar color="primary" class="toolbar-over-card" style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex; padding: 20px;">
        <div>Archive Jobs | Total Items: <span>{{totalEntries$ | async }}</span></div>
        <div style="display: flex; font-size: medium;">
          <button mat-icon-button (click)="addArchiveJob()" matTooltip="Add Archive Job">
            <mat-icon>add</mat-icon>
          </button>
          <button mat-icon-button [disabled]="(hasPreviousPage$ | async) === false" (click)="loadPreviousPage()" matTooltip="Previous page">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <button mat-icon-button [disabled]="(hasNextPage$ | async) === false" (click)="loadNextPage()" matTooltip="Next page">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      </mat-toolbar>
      <mat-card appearance="outlined" class="card-under-toolbar" style="overflow: hidden; display: flex; height: 100%;">
        <mat-card-content class="mat-elevation-z2" style="overflow: hidden; flex: auto; display: flex; flex-direction: column;">
          <div style="overflow: auto; height: 100%;">
            <table mat-table *ngIf="dataSource$ | async as dataSource" [dataSource]="dataSource" matSort class="table-width" style="width: 100%">
              <ng-container matColumnDef="archiveJobId">
                <th mat-header-cell *matHeaderCellDef matTooltip="Actionable Items" style="width: 10%"></th>
                <td mat-cell *matCellDef="let element">
                  <div *ngIf="element.status === ArchiveJobStatus.PreRun && (element.totalDocCount <= 0 || isProcessing)">
                    <span class="fal fa-ban" style="font-size: 18px; margin-right:10px;"></span>
                    <span *ngIf="element.totalDocCount <= 0" style="font-size: 16px">Empty Archive</span>
                    <span *ngIf="element.totalDocCount > 0 && isProcessing" style="font-size: 16px">Case Processing</span>
                  </div>
                  <div *ngIf="element.status === ArchiveJobStatus.PreRun && element.totalDocCount > 0 && !isProcessing" (click)="runJob(element)" class="status-action" style="cursor: pointer;">
                    <span class="fal fa-play" style="font-size: 18px;"></span>
                    <span style="font-size: 16px">Run Archive</span>
                  </div>
                  <div *ngIf="element.status === ArchiveJobStatus.Queued || element.status === ArchiveJobStatus.Running" class="status-action">
                    <mat-spinner [diameter]="22"></mat-spinner>
                    <span style="margin-left: 1px;">Running...</span>
                  </div>
                  <div *ngIf="element.status === ArchiveJobStatus.PostRun" (click)="downloadJob(element)" class="status-action" style="cursor: pointer;">
                    <mat-icon>download</mat-icon>
                    <span>Download</span>
                  </div>

                </td>
              </ng-container>
              <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef matTooltip="Title" style="width: 10%">Title</th>
                <td mat-cell *matCellDef="let element">
                  <div style="min-height: 63px; display: flex; flex-direction: column; justify-content: center; width: 350px; padding-right: 20px;">
                    <div style="font-weight: 400;">
                      <a [routerLink]="['/', 'review', 'browse']" [queryParams]="{ ArchiveJobId: element.archiveJobId }">{{element.title}}</a>
                    </div>
                    <div *ngIf="element.comments" class="comments" style="margin-top: 3px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{element.comments}}</div>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef matTooltip="status" style="width: 5%">Status</th>
                <td mat-cell *matCellDef="let element">{{ element.status }}</td>
              </ng-container>
              <ng-container matColumnDef="createdBy">
                <th mat-header-cell *matHeaderCellDef matTooltip="Created By" style="width: 10%">Created By</th>
                <td mat-cell *matCellDef="let element">{{ element.createdBy }}</td>
              </ng-container>
              <ng-container matColumnDef="runBy">
                <th mat-header-cell *matHeaderCellDef matTooltip="Run By" style="width: 10%">Run By</th>
                <td mat-cell *matCellDef="let element">{{ element.runBy }}</td>
              </ng-container>
              <ng-container matColumnDef="dateTimeCreated">
                <th mat-header-cell *matHeaderCellDef matTooltip="Created On" style="width: 15%;">Created On</th>
                <td mat-cell *matCellDef="let element">{{ element.dateTimeCreated | date: 'medium'}}</td>
              </ng-container>
              <ng-container matColumnDef="dateTimeRun">
                <th mat-header-cell *matHeaderCellDef matTooltip="Run On" style="width: 15%;">Run On</th>
                <td mat-cell *matCellDef="let element">{{ element.dateTimeRun | date: 'medium'}}</td>
              </ng-container>
              <ng-container matColumnDef="totalDocCount">
                <th mat-header-cell *matHeaderCellDef matTooltip="Total Doc Count" style="width: 5%;">Doc Count</th>
                <td mat-cell *matCellDef="let element">{{ element.totalDocCount }}</td>
              </ng-container>
              <ng-container matColumnDef="archiveBaseNumberStart">
                <th mat-header-cell *matHeaderCellDef matTooltip="archiveBaseNumberStart" style="width: 5%;">Archive Base</th>
                <td mat-cell *matCellDef="let element">{{ element.archiveBaseNumberStart }}</td>
              </ng-container>
              <ng-container matColumnDef="archiveBaseNumberDigits">
                <th mat-header-cell *matHeaderCellDef matTooltip="archiveBaseNumberDigits" style="width: 5%;">Number of Digits</th>
                <td mat-cell *matCellDef="let element">{{ element.archiveBaseNumberDigits }}</td>
              </ng-container>
              <ng-container matColumnDef="docSizeArchived">
                <th mat-header-cell *matHeaderCellDef matTooltip="docSizeArchived" style="width: 5%">Docs Size Archived</th>
                <td mat-cell *matCellDef="let element">{{ element.docSizeArchived }}</td>
              </ng-container>
              <ng-container matColumnDef="IsCreateTiff">
                <th mat-header-cell *matHeaderCellDef matTooltip="IsCreateTiff" style="width: 5%">Archive Type</th>
                <td mat-cell *matCellDef="let element">{{ element.isCreateTiff ? 'Standard Plus TIFF': 'Standard' }}</td>
              </ng-container>
              <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef matTooltip="edit" style="width: 5%"></th>
                <td mat-cell *matCellDef="let element">
                  <div style="display: flex; align-items: center;">
                    <mat-icon [routerLink]="['/', 'account', 'edit-archive', element.archiveJobId]" class="fa-light fa-pen" style="cursor: pointer;"></mat-icon>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef matTooltip="delete" style="width: 5%"></th>
                <td mat-cell *matCellDef="let element">
                  <div *ngIf="element.status === ArchiveJobStatus.PreRun || element.status === ArchiveJobStatus.PostRun" style="display: flex; align-items: center; padding-right: 20px;">
                    <mat-icon (click)="delete(element.archiveJobId)" style="cursor: pointer;">delete</mat-icon>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
              <tr mat-row *matRowDef="let row; columns:columnsToDisplay"></tr>
            </table>
          </div>
          <div class="paging-container">
            <mat-paginator [pageSize]="200" [pageSizeOptions]="[25, 50, 100, 200]"
                           [length]="totalEntries$ | async" (page)="movePage($event)" showFirstLastButtons
                           #paginator></mat-paginator>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>